export default {
  title: "Buy Tickets",
  steps: {
    findSeat: {
      title: "1. Find seat",
      text: "Choose your table and seat number during the booking process. The table number from your booking is final. Ignore any other table numbers than the ones posted on ITU LAN posters on the tables.",
    },
    buyTicket: {
      title: "2. Buy Tickets",
      text: "Buy your tickets here",
    },
    checkin: {
      title: "3. Check-in",
      text: "When you arrive, please check-in on the 1st floor. Here you will also receive your exclusive ITU LAN wristband.",
    },
  },
};
